export const Login = {
  name: "login",
  redirect: () => "https://biblogos.info/login"
};
